/**
 * Wire status codes are never displayed raw. The dot uses logical `me-*`
 * spacing so it mirrors in RTL.
 */
import { useTranslation } from "react-i18next";
import { Badge, cn } from "@erp/ui";

import type { SalesOrderStatus } from "../api";

const VARIANTS: Record<SalesOrderStatus, "outline" | "default"> = {
  draft: "outline",
  imported: "default",
};

const DOTS: Record<SalesOrderStatus, string> = {
  draft: "bg-muted-foreground",
  imported: "bg-sky-500",
};

export function SalesOrderStatusBadge({ status }: { status: SalesOrderStatus }) {
  const { t } = useTranslation();
  return (
    <Badge variant={VARIANTS[status]} className="whitespace-nowrap">
      <span
        aria-hidden="true"
        className={cn("me-1.5 inline-block size-1.5 shrink-0 rounded-full", DOTS[status])}
      />
      {t(`sales.status.${status}`, status)}
    </Badge>
  );
}
